import { render, staticRenderFns } from "./chip-op-ajustement.vue?vue&type=template&id=2cf00a7d&scoped=true"
import script from "./chip-op-ajustement.vue?vue&type=script&setup=true&lang=js"
export * from "./chip-op-ajustement.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf00a7d",
  null
  
)

export default component.exports